import angular from 'angular';
import uiRouter from 'angular-ui-router';
import FillSubCaseComponent from './fillSubCase.component';
import routing from './fillSubCase.routes';

export default angular
  .module('verifyApp.cases.fillSubCase', [uiRouter])
  .config(routing)
  .component('fillSubCase', FillSubCaseComponent)
  .name;



// WEBPACK FOOTER //
// ./client/app/cases/fillSubCase/index.js